import device from "./device"
import media from "./media"
import platform from "./platform"
import source from "./source"
import common from "./common"
import app from "./app"
import guest from "./guest"
import order from "./order"
import rc from "./rc"
import hsm from "./hsm"
import fidelio from "./fidelio"

class Platform {
  constructor() {
    this.source = source
    this.device = device
    this.media = media
    this.platform = platform
    this.common = common
    this.app = app
    this.guest = guest
    this.order = order
    this.rc = rc
    this.hsm = hsm
    this.fidelio = fidelio
  }
  _debugMode(val) {
    localStorage.debug = val
    window.location.reload(true)
  }
}

export default new Platform()
